import axios from "axios";
import useAuth from "./useAuth";
import { API_ROUTES } from "../utils/constants";

const useRefreshToken = () => {
  const { setAccessToken, setCSRFToken, setStatusAuth } = useAuth();

  const refresh = async () => {
    try {
      const response = await axios.post(
        API_ROUTES.REFRESH_TOKEN,
        {},
        {
          withCredentials: true,
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        const accessToken = response.data.access_token;
        const newCSRFToken = response.headers["x-csrftoken"] || null;

        setAccessToken(accessToken);
        setCSRFToken(newCSRFToken);
        setStatusAuth("login");
        return { accessToken, csrfToken: newCSRFToken };
      } else {
        throw new Error(`Refresh token failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error(
        "Refresh token error:",
        error.message,
        "response:",
        error.response?.data,
        "status:",
        error.response?.status
      );
      return false;
    }
  };

  return refresh;
};

export default useRefreshToken;
